import { inject, Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ApiService } from './api.service';
import { TAGPermission } from '../models/tagpermission';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService {
  private api = inject(ApiService);

  constructor() {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean> | boolean {
    return new Promise<boolean>((resolve, reject) => {
      console.log('GUARD ROOT: ', route.url);
      return resolve(true);
    });
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean> | boolean {
    //if (state.url.startsWith("/workstation/todos")) return true;
    return new Promise<boolean>(async (resolve, reject) => {
      console.log('GUARD CHILD: ', childRoute.url);

      return resolve(true);
      if (childRoute.url[0].path == 'dashboard') return resolve(true);

      await this.api.waitForAPI();
      console.log('2');
      return resolve(this.canActivateUrl(childRoute.url[0].path));
    });
  }

  canActivateUrl(url: string): Promise<boolean> | boolean {
    let userPermissions = Array.from(this.api.user()?.permissions ?? []);

    switch (url) {
      case 'mail':
        return this.api.user().technikEmail != '';
      case 'presence':
        return userPermissions.findIndex((p) => p.category == 'Presence') != -1;
      case 'gallery':
        return userPermissions.findIndex((p) => p.category == 'Images') != -1;
      case 'todos':
        return userPermissions.findIndex((p) => p.category == 'Todos') != -1;
      case 'requests':
        return userPermissions.findIndex((p) => p.category == 'Requests') != -1;
      case 'events':
        return userPermissions.findIndex((p) => p.category == 'Events') != -1;
      case 'songrequests':
        return userPermissions.findIndex((p) => p.category == 'Song Requests') != -1;
      case 'radio':
        return userPermissions.findIndex((p) => p.category == 'Schulradio') != -1;
      case 'inventory':
        return userPermissions.findIndex((p) => p.category == 'Inventory') != -1;
      case 'finances':
        return userPermissions.findIndex((p) => p.category == 'Finances') != -1;
      case 'users':
        return userPermissions.findIndex((p) => p.category == 'Users') != -1;
      case 'settings':
        return userPermissions.findIndex((p) => p.name == TAGPermission.edit_config.name) != -1;
      default:
        return true;
    }
  }
}
